// General view/UI state toggles. Accepts optional initialTabValue to forward location.state without coupling to react-router.

import { useState } from "react";

export function useSurveyState({ initialTabValue = "settings" } = {}) {
    const [tabValue, setTabValue] = useState(initialTabValue);
    const [logoDeletable, setLogoDeletable] = useState(true);
    const [instantActive, setInstantActive] = useState(false);
    const [surveyDirty, setSurveyDirty] = useState(false);

    return {
        tabValue,
        setTabValue,
        logoDeletable,
        setLogoDeletable,
        instantActive,
        setInstantActive,
        surveyDirty,
        setSurveyDirty,
    };
}
